module.exports = __webpack_public_path__ + "static/367117_1_0-43d96351a3566231763919514935ad96.woff";